import { lazy, Suspense } from 'react';
import { Outlet, type RouteObject } from 'react-router';

import { SplashScreen } from 'src/components/LoadingScreen';

const IndexPage = lazy(() => import('src/pages/home/index'));
const ContractsPage = lazy(() => import('src/pages/contracts/index'));
const AboutPage = lazy(() => import('src/pages/About'));
const SignInPage = lazy(() => import('src/pages/auth/SignIn'));
const ForgotPasswordPage = lazy(() => import('src/pages/auth/ForgotPassword'));
const ChangePasswordPage = lazy(() => import('src/pages/auth/ChangePassword'));
const Page404 = lazy(() => import('src/pages/error/404'));

import { authRoutes } from './auth';
import { procurerRoutes } from './procurer';
import { supplierRoutes } from './supplier';
import { dashboardRoutes } from './dashboard';

export const routesSection: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
        <IndexPage />
      </Suspense>
    ),
    children: [
      {
        path: '/sign-in',
        element: <SignInPage />,
      },
      {
        path: '/forgot-password',
        element: <ForgotPasswordPage />,
      },
      {
        path: '/change-password',
        element: <ChangePasswordPage />,
      },
    ],
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  ...authRoutes,
  ...procurerRoutes,
  ...supplierRoutes,
  ...dashboardRoutes,
  // No match
  { path: '*', element: <Page404 /> },
];
